<template>

    <div class="container">        
        <div class="row pt-2 pb-5">
            <div class="login-window d-flex">
                    <div class="slider reasonbg p-3">
                        <h2 class="text-center pb-3"><span>{{$t('5 reasons')}}</span> {{$t('to buy from us')}}</h2>
                        <ul class="row">
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-1"></i>
                                <p>{{ $t('We are 100 % Finnish company, we employ people in Finland, we pay taxes in Finland.') }}</p>
                            </li>
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-4"></i>
                                <p>{{ $t('We have large amount of service partners which cover all Finland, over 1000 free fitting times daily.') }}</p>
                            </li>
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-2"></i>
                                <p>{{ $t('Low prices, own big stock and wide range of tyres, part payment, many different payment methods.') }}</p>
                            </li>
                            <li class="col-md-6 text-center">
                                <i class="reason-icon reason-3"></i>
                                <p>{{ $t('Fast delivery 24h, good service, Chat open.') }}</p>
                            </li>
                            <li class="col-md-12 text-center">
                                <i class="reason-icon reason-5"></i>
                                <p>{{ $t('Purchasing tyres from Finland you help reduce CO2 emission, we sale Ecological Tyres also.') }}</p>
                            </li>
                        </ul>
                    </div>

                    <div class="become-partner-window">
                        <div class="partner-form">
                            <div v-if="loading" class="loading"></div>
                            <h1>{{$t('Reset Password')}}</h1>

                            <div v-if="isShow">
                                <bootstrap-alert 
                                    :variant="response.variant" 
                                    :msg="response.message" 
                                    :errorMsg="response.errmsg" 
                                />
                            </div>

                            <form class="w-100" @submit.prevent="onSubmit" novalidate v-if="authenticated" autocomplete="off">
                                
                                <div v-if='passwordValidation.errors.length > 0 && !form.submitted' class="alert alert-info">
                                    <strong>{{ $t('Hints') }}</strong>
                                    <ul>
                                        <li :key="error" v-for='error in passwordValidation.errors'>
                                            {{$t(error)}}
                                        </li>
                                    </ul>
                                </div>

                                <div class="matches" v-if='notSamePasswords'>
                                    <p class="text-danger">{{ $t("Passwords don't match.") }}</p>
                                </div>

                                <div class="form-group">
                                    <label for="email">
                                    {{ $t('Email Address') }}
                                    <span class="required">*</span>
                                    </label>
                                    <input 
                                        type="email" 
                                        class="form-control input-field" 
                                        id="email" 
                                        v-model="form.email" 
                                        autocomplete="off"
                                        name="email" 
                                        :placeholder="$t('Email')" />
                                </div>

                                <b-form-group :label="$t('New Password')" label-for="newpassword" class="form-group-required">
                                    <b-form-input
                                        id="newpassword"
                                        :class='{valid:passwordValidation.valid}'
                                        class="form-control input-field" 
                                        v-model="form.newpassword"
                                        type="password"
                                        maxlength="25"
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group :label="$t('Confirm new password')" label-for="confirm-newpassword" class="form-group-required">
                                    <b-form-input
                                        id="confirm-newpassword"
                                        v-model.lazy='form.confirmnewpassword'
                                        type="password"
                                        maxlength="25"
                                        class="form-control input-field" 

                                    ></b-form-input>
                                </b-form-group>

                                <input 
                                    type="submit" 
                                    class="btn btn-primary d-block w-100 login-button bg-black"
                                    :disabled="passwordsFilled && !notSamePasswords && passwordValidation.valid ? false : true"
                                    :value="$t('Submit')" />
                            </form>

                             <div class="form-group form-check" v-if="!authenticated">
                              <div class="row">
                                <!-- <div class="col-6 pl-0">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck1">
                                        <label class="custom-control-label" for="customCheck1">Remember me?</label>
                                    </div> 
                                </div>-->
                                <div class="col-12 text-right">
                                    <router-link
                                      class="color-black"
                                      :to="{ name: 'reset-password-link' }"
                                    >{{ $t("Forgot Password ?") }}</router-link>
                                  
                                </div>
                            </div>

                          </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>


</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
    metaInfo: {
        title: 'Reset Password',
        meta: [
            {name: 'description', content: 'This is reset password page'}
        ],
        link: [
            {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'resetpassword'}
        ]
    },
    data() {
        return {
            errors: [],
            authenticated: false,
            form: {
                email:'',
                newpassword: '',
                confirmnewpassword: '',
                submitted: false
            },
            rules: [
				{ message: "One lowercase letter required.", regex:/[a-z]+/ },
				{ message: "One uppercase letter required.",  regex:/[A-Z]+/ },
				{ message: "Special characters.",  regex:/[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/ },
				{ message: "8 characters minimum.", regex:/.{8,}/ },
				{ message: "One number required.", regex:/[0-9]+/ }
			],
        }
    },
    created () {
        this.checkAuth()
    },
    watch: {
        '$route': 'checkAuth'
    },
    computed: {
        ...mapGetters('resetpassword', ['response', 'isShow', 'loading']),
        ...mapGetters('app', ['currentLang']),
        notSamePasswords () {
			if (this.passwordsFilled) {
				return (this.form.newpassword !== this.form.confirmnewpassword)
			} else {
				return false
			}
        },
        passwordsFilled () {
			return (this.form.newpassword !== '' && this.form.confirmnewpassword !== '')
		},
		passwordValidation () {
			let errors = [];
			for (let condition of this.rules) {
				if (!condition.regex.test(this.form.newpassword)) {
                    errors.push(condition.message)
				}
            }
            
			if (errors.length === 0) {
				return { valid: true, errors }
			} else {
				return { valid: false, errors }
			}
		}
    },
    methods: {
        ...mapActions('resetpassword', ['checkTokenAuthentication', 'setIsShow', 'resetPassword', 'showError', 'resetError']),
        ...mapActions('auth', ['logout']),
        checkAuth () {
            this.setIsShow(true)
            let token = this.$route.params.token
            this.checkTokenAuthentication({
                        token: token,
                        lang: this.currentLang
                    })
                .then((response) => {
                    this.authenticated = true
                })
                .catch((error) => {
                    this.authenticated = false
                })
        },
        onSubmit() {
            this.resetPassword({email: this.form.email, password: this.form.confirmnewpassword, token: this.$route.params.token, lang: this.currentLang})
            .then((response) => {
                this.$router.push({ 
                    path: '/login', params: {}, replace: true
                }).catch(err => {});
            })
            .catch(error => {
                
            })
        }
    },
    destroyed(){
        // this.setIsShow(false)
    }
};
</script>